/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetAnthropicInferenceConfigSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type GetAnthropicInferenceConfigRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type GetAnthropicInferenceConfigSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetAnthropicInferenceConfigSecurity$outboundSchema: z.ZodMiniType<
  GetAnthropicInferenceConfigSecurity$Outbound,
  GetAnthropicInferenceConfigSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getAnthropicInferenceConfigSecurityToJSON(
  getAnthropicInferenceConfigSecurity: GetAnthropicInferenceConfigSecurity,
): string {
  return JSON.stringify(
    GetAnthropicInferenceConfigSecurity$outboundSchema.parse(
      getAnthropicInferenceConfigSecurity,
    ),
  );
}

/** @internal */
export type GetAnthropicInferenceConfigRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const GetAnthropicInferenceConfigRequest$outboundSchema: z.ZodMiniType<
  GetAnthropicInferenceConfigRequest$Outbound,
  GetAnthropicInferenceConfigRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
    });
  }),
);

export function getAnthropicInferenceConfigRequestToJSON(
  getAnthropicInferenceConfigRequest: GetAnthropicInferenceConfigRequest,
): string {
  return JSON.stringify(
    GetAnthropicInferenceConfigRequest$outboundSchema.parse(
      getAnthropicInferenceConfigRequest,
    ),
  );
}
